import React from 'react';

import NavBar from '../components/NavBar';



function ResidentManager() {
    return (
        <>
            <div className='h1'>
            <h1>Resident Manager</h1> 
            </div>
            <div className='parent'>
                <div className='child'>
                    <label>
                        Add RM: 
                    </label>
                    <input type="text" placeholder="First Name*" />
                    <input type="text" placeholder="Last Name*" />
                    <input type="text" placeholder="Email" />
                    <input type="text" placeholder="Phone*" />
                    <input type="submit" value="Submit" />
                    <div className='center-note'>
                        <p>* indicates a required field.</p>
                    </div>
                </div>
              
                <div className='child'>
                    <label>
                        Search RMs: 
                    </label>
                    <input type="text" placeholder="First Name" />
                    <input type="text" placeholder="Last Name" />
                    <input type="text" placeholder="Email" />
                    <input type="text" placeholder="Phone" />
                    <input type="submit" value="Submit" />
                </div>
            </div>
            <div className='center-paragraph'>
                <p>* Deleting a resident manager will delete all resident manager assignments associated with that property.</p>
            </div>
            <table id="customers" className='center-table'>
                <tr>
                    <th>RM ID</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th></th>
                </tr>
                <tr>
                    <td>000001</td>
                    <td>Alice</td>
                    <td>Apple</td>
                    <td>aapple@email.com</td>
                    <td>(999)999-9999</td>
                    <td><button>Edit</button><button>Delete</button></td>
                </tr>
                <tr>
                    <td>000002</td>
                    <td>David</td>
                    <td>Danes</td>
                    <td>dd@email.com</td>
                    <td>(999)999-9996</td>
                    <td><button>Edit</button><button>Delete</button></td>
                </tr>
            </table>
            <br></br>

            <div>
                <NavBar/>
            </div>
        </>
    );
}

export default ResidentManager;